var styles = {"body":"bc-LtiModal__body"};

export { styles as default };
